import LichThiDauByCountrySidebar from "@/components/LichThiDauByCountrySidebar";

/**
 * @param {object} props
 * @param {string} props.country
 */
export default function BangKeoKetQuaByCountrySidebar({ country }) {
  return <LichThiDauByCountrySidebar country={country} type="ketqua" />;
}
